import { mapState } from "vuex";
export const shopIndexMixins = {
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      isOwn: (state) => state.isOwn,
    }),
    shopTopBarList() {
      let topbarList = [
        {
          name: "门店管理",
          isActive: false,
          path: "/shop",
          icon:require("@/assets/img/menuIcons/icon-shop.png")
        },
        // {
        //   name: "员工管理",
        //   isActive: false,
        //   path: "/shop/staff",
        // },,
      ];
      if (this.shopInfo.edcShopType == 16) {
        topbarList.push(
          {
            name: "餐厅管理",
            isActive: false,
            path: "/shop/canteen",
            icon:require("@/assets/img/menuIcons/icon-shopcanteen.png")
          },
          {
            name: "楼宇管理",
            isActive: false,
            path: "/shop/floor",
            icon:require("@/assets/img/menuIcons/icon-shopfloor.png")
          }
        )
      }
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
      });
      return topbarList;
    },
  },
}
